import { Component, OnInit, ChangeDetectorRef, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from '../../servicios/alert.service';
import { loading_show, loading_hide } from '../../app.helpers';
import { setTimeout } from 'timers';
import { Result } from '../../servicios/servers.service';
import swal from 'sweetalert2';
import { ChangeDetectorStatus } from '@angular/core/src/change_detection/constants';
import { PersonaService } from '../../servicios/persona.service';
import { BsModalService,BsModalComponent } from 'ng2-bs3-modal';
import { MessagingService } from '../../servicios/messaging.service';
import { Subscription } from 'rxjs/Subscription';
declare var google;
declare var jQuery: any;

@Component({
    selector: 'geolocalizacion',
    templateUrl: 'geolocalizacion.template.html'
})

export class GeolocalizacionComponent implements OnInit, OnDestroy {

    @ViewChild('modal')
    public modal: BsModalComponent;
    @ViewChild('modal2')
    public modal2: BsModalComponent;
    @ViewChild('modal3')
    public modal3: BsModalComponent;
    @ViewChild('modal4')
    public modal4: BsModalComponent;
    model: any = {};
    loading = false;
    returnUrl: string;
    cliente:any= {};
    barrio:any= {};
    btnPedirServicio= false;
    btnBarrio = false;
    marker:any = null;
    markerBarrio:any = null;
    geocoder:any = null;
    map:any= null;
    map2:any= null;
    lat = 4.6482837;
    lng: number = -74.2478914;
    latGlobal:number=null;
    lngGlobal:number=null;
    conductores:any=[];
    markers:any=[];
    detalles:any =[];
    circle:any;
    circleServicio:any;
    centerLastMarker:any;
    barrios:any=[];
    barrioSelect= false;
    barrioSeleccionado:any = {};

    infowindowactual:any=null;

    public fecha= {start:'', end:''};

    latLngCenter:any;
    servicio:any={};
    servicios:any = [];

    private payloadFcm: Subscription = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private personaService:PersonaService,
        private alertService: AlertService,
        private cdr: ChangeDetectorRef,
        private modalService: BsModalService,
        private msgService: MessagingService
    ) {  }

    ngOnDestroy() {
        this.payloadFcm.unsubscribe();
    }

    ngOnInit() {

        this.servicio.tipoServicio = 1;
        this.servicio.ciudad = 'valledupar';
        this.payloadFcm = this.msgService.payload.subscribe((payload)=> {

            // alert(JSON.stringify(payload));
            this.getReporte();

        });

        this.barrio.radio = '0.1';
        const mapProp= {
            center: new google.maps.LatLng(this.lat,this.lng),
            zoom:6,
        };

        this.map = new google.maps.Map(document.getElementById('googleMap'),mapProp);
        this.map2 = new google.maps.Map(document.getElementById('googleMap2'),mapProp);

        this.geocoder= new google.maps.Geocoder();

        this.map.addListener('click', (e)=> {
            this.placeMarkerAndPanTo(e.latLng);
        });

        this.map2.addListener('click', (e)=> {
            this.placeMarkerAndPanToBarrio(e.latLng);
        });

        this.servicio.tipoServicio = 1;

        const fecha = new Date();
        let mes:any = fecha.getMonth() + 1;
        if(mes<10) { mes = '0' + mes; }
        this.fecha.start =  fecha.getFullYear() + '-' + mes + '-' + fecha.getDate();
        this.fecha.end =  fecha.getFullYear() + '-' + mes + '-' + fecha.getDate();

        this.setCiudad();
        this.getReporte();
        this.getBarrios();


        setInterval(() => this.getConductores() , 1 * 60000);
        setInterval(() => this.getReporte() , 1 * 60000);

    }

    setLatLng(latLng) {
        this.lat = latLng.lat();
        this.lng = latLng.lng();
        // console.log(this.lat+", "+this.lng);
    }

    placeMarkerAndPanTo(latLng) {
        this.deleteMarker();
        this.deleteCircleServicio();
        this.unselectBarrio();
        this.marker = new google.maps.Marker({
          position: latLng,
          map: this.map
        });

        this.map.panTo(latLng);
        this.geocodeLatLng(latLng);
        this.setLatLng(latLng);
    }

    placeMarkerAndPanToBarrio(latLng) {
        this.btnBarrio = true;
        this.deleteMarkerBarrio();
        this.markerBarrio = new google.maps.Marker({
          position: latLng,
          map: this.map2,
          draggable:true
        });

        google.maps.event.addListener(this.markerBarrio, 'dragend', ()=> {
            this.markerDragEnd(this.markerBarrio.getPosition());
        });

        this.centerLastMarker= latLng;

        this.circle = new google.maps.Circle({
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
            map: this.map2,
            center:latLng,
            radius: this.barrio.radio *10 * 100
          });

        this.map2.panTo(latLng);

    }

    geocodeLatLng(latLng) {

        this.geocoder.geocode({'location': latLng}, (results, status)=> {
          if (status === 'OK') {
            if (results[0]) {
                // console.log(results);
                // this.map.setZoom(14);
                const googleAddress = results[0].formatted_address;
                const arr = googleAddress.split(',');
                this.servicio.direccion  = arr[0];
                this.btnPedirServicio = true;
                this.cdr.detectChanges();
            } else {
              window.alert('No results found');
            }
          } else {
            window.alert('Geocoder failed due to: ' + status);
          }
        });
    }

    getConductores() {

        // loading_show();
        const object = {
            idTipoServicio: this.servicio.tipoServicio,
            latitud: this.latGlobal,
            longitud: this.lngGlobal
        };
        this.personaService.getConductoresByTipoServicioBackend(object,(data: any) => {
            // loading_hide();
            if (data.message=='Correcto') {

                this.conductores = data.Data;
                this.mostrarTaxistas();

            }else {
                this.conductores = [];
                this.limpiarMapa();
            }

        });

    }

    limpiarMapa() {
        if(this.markers.length>0) {

            for(let j =0; j<this.markers.length; j++) {
                const m = this.markers[j];
                m.setMap(null);
            }
        }
        this.markers=[];

    }

    mostrarTaxistas() {

        setTimeout(()=> {

            this.limpiarMapa();

            for(let i =0; i<this.conductores.length; i++) {

                const coorMarcador = new google.maps.LatLng(this.conductores[i].latitud, this.conductores[i].longitud);

                let img = 'assets/img/markers/market_taxi.png';
                if(this.servicio.tipoServicio == 1) {
                    if(this.conductores[i].estado == 'DISPONIBLE') {
                        img = 'assets/img/markers/Market_taxi_disponible.png';
                    }else {
                        img = 'assets/img/markers/Market_taxi_ocupado.png';
                    }

                }
                if(this.servicio.tipoServicio == 2) {
                    img = 'assets/img/markers/Market_Policia.png';
                }
                if(this.servicio.tipoServicio == 3) {
                    img = 'assets/img/markers/Market_Ambulancia.png';
                }
                if(this.servicio.tipoServicio == 4) {
                    img = 'assets/img/markers/Market_Bomberos.png';
                }
                if(this.servicio.tipoServicio == 5) {
                    img = 'assets/img/markers/Market_Grua.png';
                }
                if(this.servicio.tipoServicio == 6) {
                    img = 'assets/img/markers/Market_Domicilio.png';
                }

                const image = {
                    url: img,
                    scaledSize: new google.maps.Size(25, 40), // scaled size
                    origin: new google.maps.Point(0,0), // origin
                    anchor: new google.maps.Point(0, 0) // anchor
                  };

                  const marker = new google.maps.Marker({
                    position: coorMarcador,
                    map: this.map,
                    icon:image
                });

                this.markers.push( marker );

                const m = this.markers[i];
                const cond = this.conductores[i];
                m.newA = cond;

                const __this = this;
                m.addListener('click', function(){
                   __this.mostrarInfoWindow(this);
                });

            }

        },2000);
    }

    mostrarInfoWindow(marker) {

        if(this.infowindowactual != null){
            this.infowindowactual.close();
        }

        var contentString = '<div id="iw-container">'+
                                '<div class="iw-title">Datos del Conductor</div>'+
                                '<div class="iw-content">' +
                                    '<div class="iw-subTitle">'+marker.newA.nombre+' '+marker.newA.apellidos+'</div>' +
                                    '<p>Tel. '+marker.newA.telefono+'<br>Placas: '+marker.newA.placa+'</p>'+
                                '</div>' +
                                '<div class="iw-bottom-gradient"></div>' +
                            '</div>';

        var infowindow = new google.maps.InfoWindow({
            content: contentString,
            maxWidth: 339
        });

        google.maps.event.addListener(infowindow, 'domready', function() {

            // Reference to the DIV that wraps the bottom of infowindow
            var iwOuter = jQuery('.gm-style-iw');

            /* Since this div is in a position prior to .gm-div style-iw.
            * We use jQuery and create a iwBackground variable,
            * and took advantage of the existing reference .gm-style-iw for the previous div with .prev().
            */
            var iwBackground = iwOuter.prev();

            // Removes background shadow DIV
            iwBackground.children(':nth-child(2)').css({'display' : 'none'});

            // Removes white background DIV
            iwBackground.children(':nth-child(4)').css({'display' : 'none'});

            // Moves the infowindow 115px to the right.
            iwOuter.parent().parent().css({left: '0'});

            // Moves the shadow of the arrow 76px to the left margin.
            iwBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});

            // Moves the arrow 76px to the left margin.
            iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});

            // Changes the desired tail shadow color.
            iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

            // Reference to the div that groups the close button elements.
            var iwCloseBtn = iwOuter.next();

            // Apply the desired effect to the close button
            iwCloseBtn.css({opacity: '1', right: '49px', top: '8px', border: '1px solid #48b5e9', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9', 'width':'15px', 'height':'15px'});

            // If the content of infowindow not exceed the set maximum height, then the gradient is removed.
            if(jQuery('.iw-content').height() < 140){
            jQuery('.iw-bottom-gradient').css({display: 'none'});
            }

            // The API automatically applies 0.7 opacity to the button after the mouseout event. This function reverses this event to the desired value.
            iwCloseBtn.mouseout(function(){
                jQuery(this).css({opacity: '1'});
            });
        });

        infowindow.open(this.map, marker);
        this.infowindowactual = infowindow;
    }

    showDetalles(servicio){
         loading_show();
         var object ={
            idServicio: servicio.id
        }
        this.personaService.getLogServicio(object,(data: any) => {
            loading_hide();
            if (data.isOk) {
                
                this.modal3.open();
                this.detalles = data.Content;

            }else{
                this.detalles = [];
            }

        });
    }

    getReporte(){

        //loading_show();
        var object ={
            fecha_ini: this.fecha.start,
            fecha_fin: this.fecha.end
        }
        this.personaService.getServiciosBackend(object,(data: any) => {
            //loading_hide();
            if (data.isOk) {
                
                this.servicios = data.Content;

            }else{
                this.servicios = [];
            }

        });
    }

    setCiudad(){

        this.deleteMarker();
        this.geocoder.geocode({'address': this.servicio.ciudad}, (results, status) =>{
            if (status === 'OK') {
                this.latLngCenter = results[0].geometry.location;
                this.map.setCenter(results[0].geometry.location);

                this.latGlobal = results[0].geometry.location.lat();
                this.lngGlobal = results[0].geometry.location.lng();

                this.map.setZoom(13);
                this.getConductores();
            } else {
              alert('Geocode was not successful for the following reason: ' + status);
            }
          });
    }

    setCiudadToBarrio(){

        this.deleteMarkerBarrio();
        this.geocoder.geocode({'address': this.barrio.ciudad}, (results, status) =>{
            if (status === 'OK') {
                //this.latLngCenter = results[0].geometry.location;
                this.map2.setCenter(results[0].geometry.location);

                //this.latGlobal = results[0].geometry.location.lat();
                //this.lngGlobal = results[0].geometry.location.lng();
                this.map2.setZoom(13);

            } else {
              alert('Geocode was not successful for the following reason: ' + status);
            }
          });
    }

    deleteMarker(){
        if(this.marker != null)
            this.marker.setMap(null);
    }

    deleteMarkerBarrio(){
        if(this.markerBarrio != null)
            this.markerBarrio.setMap(null);
            
       this.deleteCircle();
    }
    
    deleteCircle(){ 
        if(this.circle != null)
        this.circle.setMap(null);
    }

    deleteCircleServicio(){ 
        if(this.circleServicio != null)
        this.circleServicio.setMap(null);
    }

    buscarDireccion(event:any){

        var bandera = false;
        
        //if(this.barrioSelect ==true){
            this.btnPedirServicio = true;            
            

            if(event == null){
                bandera = true;
            }else{
                if(event == "boton"){
                    bandera = true;
                }
                if(event == "focus"){
                    bandera = false;
                }
    
                if(event.keyCode == 13){
                    bandera = true;
                }
            }

        //}else{

            //bandera = false;

        //}
        this.barrioSelect = false;
        if(bandera == true) {
            this.deleteMarker();
            this.deleteCircleServicio();
            this.geocoder.geocode({'address': this.servicio.ciudad+", "+this.servicio.direccion},(results, status) =>{
                if (status === 'OK') {
                    
                    this.map.setCenter(results[0].geometry.location);
                    this.map.setZoom(14);
                    
                    this.marker = new google.maps.Marker({
                        map: this.map,
                        position: results[0].geometry.location
                    });

                    this.setLatLng(results[0].geometry.location);
                    this.btnPedirServicio = true;
                    this.cdr.detectChanges();

                } else {
                    
                    alert("Por favor escriba una dirección que pueda reconocer el MAPA");
                    this.btnPedirServicio = false;
                    this.cdr.detectChanges();
                    jQuery("direccion").off( "focusout" );

                }
              }); 

        }
    }

    buscarCliente(event){
        this.cliente = {};
        
        if(event == null || event.keyCode == 13) {
            
            if(this.servicio.ciudad != 0 && this.servicio.ciudad != undefined){
                loading_show();
                this.personaService.getByTelefono(this.servicio.telefono,(data: any) => {
                    loading_hide();
                    if (data.isOk) {
                       this.unselectBarrio();
                        if(data.Content == null){
                            this.cliente.telefono = this.servicio.telefono;
                            this.modal.open();
                        }else{

                            this.cliente = data.Content;
                            this.servicio.direccion = data.Content.direccion;
                            this.buscarDireccion(null);
                            
                            jQuery("#direccion").focus();
                            
                        }
                        
                    }
    
                });
            }else{

                alert("Escoge una Ciudad");
            }
            
        }
    }

    pedirServicio(){

        if(!this.cliente.id){
            this.cliente.id = null;
            //swal({type: 'error', title: 'Error', text: "Debes consultar o agregar a un cliente"})
            //return "";
        }

        var token = localStorage.getItem("firebaseToken");

        var object = {
            privado:false,
            latitud: this.lat,
            longitud: this.lng,
            tipoServicio:this.servicio.tipoServicio,
            idCliente: this.cliente.id,
            direccion: this.servicio.direccion,
            detalles:  this.servicio.detalles,
            telefono: this.servicio.telefono,
            updateDireccion: this.servicio.updateDireccion,
            isBackend: true,
            token:token
        }
        console.log(object);
        
        loading_show();
        this.personaService.saveServicio(object, (data: Result) => {
            this.modal2Cancelar();
            loading_hide();

            if (data.isOk) {
                
                this.cliente = {};
                this.servicio.telefono = "";
                this.servicio.direccion = "";
                this.servicio.detalles = "";
                this.servicio.updateDireccion = false;
                this.deleteMarker();
                this.getReporte();

                swal({type: 'success', title: 'Correcto', text: data.Mensaje})
                
            }else{
                swal({type: 'error', title: 'Error', text: data.Mensaje})
            }
        });
 
    }

    guardarCliente(event){
        
        if(event == null || event.keyCode == 13) {
            var object = {
                'nombre': this.cliente.nombre,
                'apellidos': this.cliente.apellidos,
                'direccion':this.cliente.direccion,
                'telefono':this.cliente.telefono
            }
        
            loading_show();
            this.personaService.saveCliente(object, (data: Result) => {
                loading_hide();
    
                if (data.isOk) {
                    this.cliente = {};
                    swal({type: 'success', title: 'Correcto', text: data.Mensaje})
                    this.servicio.direccion = this.cliente.direccion;
                    this.modal.close();
                    this.buscarCliente(null);
                }else{
                    swal({type: 'error', title: 'Error', text: data.Mensaje})
                    
                }
            });
            
        }
        
    }

    updateDireccion(){
    
        var object = {
            'id': this.cliente.id,
            'direccion':this.servicio.direccion
        }
    
        loading_show();
        this.personaService.saveCliente(object, (data: Result) => {
            loading_hide();

            if (data.isOk) {
                this.cliente = {};
                swal({type: 'success', title: 'Correcto', text: data.Mensaje})
                this.servicio.direccion = this.cliente.direccion;
                this.modal.close();
                this.buscarCliente(null);
            }else{
                swal({type: 'error', title: 'Error', text: data.Mensaje})
                
            }
        });
            
    }

    modalCancelar(){
        this.cliente = {};
        this.modal.close();
    }

    modalCancelarDetalles(){
        this.detalles = [];
        this.modal3.close();
    }

    modal2Cancelar(){
        this.servicio.updateDireccion = false;
        this.modal2.close();
    }

    modalServicio(){
        if(!this.servicio.telefono || this.servicio.telefono == ""){
            
            swal({type: 'error', title: 'Error', text: "Debes Escribir el teléfono del Cliente"})
            return "";
        }

        if(!this.servicio.direccion || this.servicio.direccion == ""){
            
            swal({type: 'error', title: 'Error', text: "Debes Escribir la dirección del Cliente"})
            return "";
        }

        if(this.barrioSelect == true){
            this.servicio.direccion += "; " +this.barrioSeleccionado.nombre; 
        }
        this.servicio.updateDireccion  = false;
        this.modal2.open();
        
    }

    cancelService(servicio:any){
        var  _this = this;
        swal({
            title: '¿Cancelar Servicio?',
            text: "¿Estas Seguro de Cancelar el Servicio?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'SI, Cancelar',
            cancelButtonText:'No'

          }).then(() => {

            var object = {
                'idServicio': servicio.id,
                'estado':'CANCELADO',
                'idCliente':"null",
                'isCliente':"1"
            }
        
            loading_show();
            _this.personaService.cambiarEstado(object, (data: Result) => {
                loading_hide();
    
                if (data.isOk) {
                    _this.getReporte();
                    swal({type: 'success', title: 'Correcto', text: data.Mensaje})
                    
                }else{
                    swal({type: 'error', title: 'Error', text: data.Mensaje})
                    
                }
            });
            
          })
        
    }

    eliminarBarrio(idBarrio:any){

        var object = {"idBarrio":idBarrio};

        this.personaService.deleteBarrio(object,(data: any) => {

            if (data.isOk) {
                alert("Eliminado Correctamente");
                this.getBarrios();
                //swal({type: 'success', title: 'Correcto', text: data.Mensaje});
            }else{
                swal({type: 'error', title: 'Error', text: data.Mensaje});
            }
            
            
        });

    }

    getBarrios(){
        
        this.personaService.getBarrios((data: any) => {
            
            if (data.isOk) {

                console.log(data.Content);
                this.barrios=[];
                this.barrios = data.Content;
                
                this.cdr.detectChanges();
            }else{
                this.barrios =[]
            }

        });
    }

    dibujarRadio(){
        
        setTimeout(()=>{
            this.deleteCircle();
            this.circle = new google.maps.Circle({
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#FF0000',
                fillOpacity: 0.35,
                map: this.map2,
                center:this.centerLastMarker,
                radius: this.barrio.radio *10 * 100
              });
        },500)

    }

    dibujarRadioServicio(radio,LatLng){
        
        setTimeout(()=>{
            this.deleteCircleServicio();
            this.circleServicio = new google.maps.Circle({
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#FF0000',
                fillOpacity: 0.35,
                map: this.map,
                center:LatLng,
                radius: radio *10 * 100
              });
        },500)

    }

    guardarBarrio(){
        if(!this.barrio.nombre){
            alert("Debes escribir el nombre del barrio");
        }else{

            loading_show();
            var object = {
                "nombre":this.barrio.nombre,
                "latitud": this.centerLastMarker.lat(),
                "longitud": this.centerLastMarker.lng(),
                "radio": this.barrio.radio,
                "ciudad": this.barrio.ciudad
            };

            this.personaService.saveBarrio(object,(data: any) => {
                loading_hide();
                if (data.isOk) {
                    swal({type: 'success', title: 'Correcto', text: data.Mensaje})
                    this.getBarrios();
                }else{
                    swal({type: 'error', title: 'Error', text: data.Mensaje})
                }

            });
        }
    }

    buscarBarrio(event){
        
        if(event == null || event.keyCode == 13) {
            this.btnBarrio = true;
            this.deleteMarkerBarrio();
            this.geocoder.geocode({'address': this.barrio.ciudad+", "+this.barrio.nombre},(results, status) =>{
                if (status === 'OK') {
                    
                    this.map2.setCenter(results[0].geometry.location);
                    this.map2.setZoom(16);
                    
                    this.markerBarrio = new google.maps.Marker({
                        map: this.map2,
                        position: results[0].geometry.location,
                        draggable:true,
                    });

                    google.maps.event.addListener(this.markerBarrio, 'dragend', ()=> 
                    {
                        this.markerDragEnd(this.markerBarrio.getPosition());
                    });

                    this.centerLastMarker =results[0].geometry.location;
                    this.dibujarRadio();

                } else {
                    
                    alert("Por favor escriba una dirección que pueda reconocer el MAPA");
                    jQuery("nombreBarrio").off( "focusout" );

                }
              }); 

        }
    }

    markerDragEnd(pos:any){

        this.btnBarrio = true;
        //this.barrio = {radio: "0.1", ciudad: this.barrio.ciudad};
        this.centerLastMarker = pos;
        this.dibujarRadio();
        
    }

    showBarrio(barrio:any){

        this.btnBarrio = false;
        this.barrio  = barrio;
        this.deleteMarkerBarrio();
        
        this.centerLastMarker = new google.maps.LatLng(barrio.latitud,barrio.longitud);

        this.map2.setCenter(this.centerLastMarker);

        this.map2.setZoom(16);

        this.markerBarrio = new google.maps.Marker({
            map: this.map2,
            position: this.centerLastMarker,
            draggable:true
        });

        google.maps.event.addListener(this.markerBarrio, 'dragend', ()=> 
        {
            this.markerDragEnd(this.markerBarrio.getPosition());
        });
        
        this.dibujarRadio();
        
    }

    onSelect(event:any){
        this.deleteMarker();
        this.barrioSelect = true;
        var bar = this.getBarrio(event.id);
        this.barrioSeleccionado = bar;
        var latLng = new google.maps.LatLng(bar.latitud,bar.longitud);
        this.marker = new google.maps.Marker({
            position: latLng,
            map: this.map
          });
  
        this.map.panTo(latLng);
        this.map.setZoom(16);

        //this.geocodeLatLng(latLng)
        this.setLatLng(latLng);
        
        this.dibujarRadioServicio(bar.radio,latLng);

        console.log(event.id);
    }

    getBarrio(idBarrio){
        var barrio = null;
        for (const entry of this.barrios) {
            if(entry.id == idBarrio){

                barrio = entry;

            }
        }
        return barrio;
    }

    unselectBarrio(){
        this.servicio.barrio = null;
        this.barrioSelect = false;
    }

    reenviarServicio(item:any){
       

        loading_show();
        var object = {
            "idServicio":item.id
        };

        this.personaService.reenviarServicio(object,(data: any) => {
            loading_hide();
            if (data.isOk) {
                
                this.getReporte();
                swal({type: 'success', title: 'Correcto', text: data.Mensaje})
                
            }else{
                swal({type: 'error', title: 'Error', text: data.Mensaje})
            }

        });
    }
 
 }


// WEBPACK FOOTER //
// ./src/app/views/geolocalizacion/geolocalizacion.component.ts